module.exports = __webpack_public_path__ + "img/ic_filter.d5927d92.svg";